import { useState } from 'react'

import { useDraftCreationModalOpener } from '../../../Draft'
import {
  useEmailCreationFormInitialValues,
  useEmailGetActiveAccountForCreate,
} from '../../../Email'
import { MINIMIZED_MODAL_KEY } from '../../../Modal'
import {
  EPOST_CONTACT_SUPPORT_EMAIL_MODAL_INITIAL_VALUES,
  EPOST_SUPPORT_MODAL_SOURCE_ID,
} from '../../EpostContactSupportEmailModal'

export function useEpostSupportModal() {
  const [isOpenModal, setOpenModal] = useState(false)

  function handleCloseModal() {
    setOpenModal(false)
  }

  function openModal() {
    setOpenModal(true)
  }

  const handleOpenModal = useDraftCreationModalOpener({
    minimizeKey: MINIMIZED_MODAL_KEY.EMAIL_FORM,
    sourceId: EPOST_SUPPORT_MODAL_SOURCE_ID,
    onOpen: openModal,
  })

  const { activeAccountForCreate } = useEmailGetActiveAccountForCreate()

  const initialValues = useEmailCreationFormInitialValues({
    account: activeAccountForCreate,
    initialValues: EPOST_CONTACT_SUPPORT_EMAIL_MODAL_INITIAL_VALUES,
  })

  return {
    handleCloseModal,
    handleOpenModal,
    initialValues,
    isOpenModal,
  }
}
